import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import { Spinner } from '@components/atoms';
import { useSignIn } from '../hooks/signIn';

export default function OAuthPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasAuthenticated = useRef(false);

  const signIn = useSignIn({
    onError: () => {
      navigate('/auth/login');
    },
  });

  useEffect(() => {
    const code = searchParams.get('code');

    if (!code) {
      navigate('/auth/login');
      return;
    }

    if (!hasAuthenticated.current) {
      hasAuthenticated.current = true;
      signIn.onSuccess({ code });
    }
  }, [searchParams, navigate, signIn]);

  return <Spinner open={signIn.isLoading} />;
}
